import React from 'react';
import styled from 'styled-components';
import { CategoryData } from '../quantData';
import { useModal } from '../../../context/ModalContext';
import { useQuantContext } from '../../../context/QuantContext';

interface Props {
  userGrade: string | null;
}

function CategorySelect({ userGrade }: Props) {
  const { modalDispatch } = useModal();
  const { selectedCategory, setSelectedCategory } = useQuantContext();
  const handleClick = (category: string) => {
    if (!userGrade) {
      modalDispatch({ type: 'USER_ALERT', payload: 'free' });
      return;
    }

    if (category === '물건 전체') {
      setSelectedCategory([]);
    } else {
      if (selectedCategory.includes(category)) {
        setSelectedCategory(selectedCategory.filter((r) => r !== category));
      } else {
        setSelectedCategory([...selectedCategory, category]);
      }
    }
  };

  const checkSelected = (category: string) => {
    if (category === '물건 전체') {
      if (selectedCategory.length > 0) return false;
      return true;
    } else {
      return selectedCategory.includes(category);
    }
  };

  return (
    <Container>
      <Title>물건 선택</Title>
      <OptionWrapper>
        {CategoryData.map((item) => (
          <OptionItem key={item.image} onClick={() => handleClick(item.name)}>
            <OptionImg $isSelected={checkSelected(item.name)}>
              <img
                src={'/assets/images/quant/' + item.image + '.svg'}
                alt=""
                style={{ width: '40px', height: '40px', objectFit: 'cover' }}
              />
            </OptionImg>
            <OptionName $isSelected={checkSelected(item.name)}>
              {item.name}
            </OptionName>
          </OptionItem>
        ))}
      </OptionWrapper>
    </Container>
  );
}

export default CategorySelect;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const Title = styled.div`
  color: #222;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: auto;
  width: 100%;
`;

const OptionItem = styled.div`
  display: flex;
  min-width: 76px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const OptionImg = styled.div<{ $isSelected?: boolean }>`
  width: 100%;
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: ${({ $isSelected }) =>
    $isSelected ? '2px solid #008AFF' : '1px solid #E5E8EA'};
  background: var(--component-fill-assistive, #f7f8fc);
`;

const OptionName = styled.div<{ $isSelected?: boolean }>`
  color: ${({ $isSelected }) => ($isSelected ? '#008AFF' : '#616161')};
  text-align: center;
  font-size: 13px;
  font-weight: ${({ $isSelected }) => ($isSelected ? '700' : '500')};
  line-height: 150%; /* 19.5px */
  letter-spacing: -0.26px;
`;
